<template>
    <div id="page-title" class="row pt-4 pb-4">
            <div class="col-12" :class="align">
                <h4 class="text-center text-lg-left">
                    <i class="fa fa-star"></i> {{ title }}
                </h4>
            </div>
        </div>
</template>

<script>
export default {
    name: 'PageTitle',
    props: ['title', 'align']
}
</script>

<style lang="scss" scoped>
    h4 {
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-size: 14px;
        clear: both;
        color: #888;
    }

    i {
        font-size: 9px;
        background: #E73737;
        color: #fff;
        width: 22px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border-radius: 50%;
        letter-spacing: 0;
        margin-right: 7px!important;
        vertical-align: middle;
        margin-top: -3px;
    }
</style>
